import { useCallback } from 'react'

type UseKeyboardReorderingProps = {
	fieldsOrder: string[]
	itemsLength: number
	onReorder: (newFieldsOrder: string[], fieldId: string) => void
}

export function useKeyboardReordering({ fieldsOrder, itemsLength, onReorder }: UseKeyboardReorderingProps) {
	const getKeyDownListener = useCallback(
		(fieldId: string) => (event: React.KeyboardEvent) => {
			if (!['ArrowUp', 'ArrowDown'].includes(event.key)) {
				return
			}
			event.preventDefault()

			const isMovingUp = event.key === 'ArrowUp'
			const initIndex = fieldsOrder.findIndex((id) => id === fieldId)

			if (isMovingUp && initIndex < 1) {
				return
			}
			if (!isMovingUp && itemsLength - 1 <= initIndex) {
				return
			}

			const destinationIndex = isMovingUp ? initIndex - 1 : initIndex + 1
			const newFieldsOrder = [...fieldsOrder]
			const [movedItem] = newFieldsOrder.splice(initIndex, 1)
			newFieldsOrder.splice(destinationIndex, 0, movedItem)

			onReorder(newFieldsOrder, fieldId)
		},
		[fieldsOrder, itemsLength, onReorder],
	)

	return { getKeyDownListener }
}
